<template>
  <div class="p-4">
    <h1 class="text-2xl font-semibold mb-4">Reports</h1>

    <EditableGrid
        :fetch-data-query="listReportMutation"
        :update-mutation="updateReportMutation"
        :column-defs="columnDefs"
        primary-key="report_id"
        show-hospitals-dropdown
        :components="gridComponents"
        :context="gridContext"
    />
  </div>
</template>

<script>
import EditableGrid from "@/components/common/EditableGrid.vue";
import ListSizeRenderer from '@/components/common/ListSizeRenderer.vue';
import ListEditor from '@/components/common/ListEditor.vue';
import ListTooltip from '@/components/common/ListTooltip.vue';
import HospitalSelector from "@/components/common/HospitalSelector.vue";

import {listReports, updateReports} from '@/graphql/reports.graphql';

export default {
  name: 'ReportsPage',
  components: {
    EditableGrid,
  },
  data() {
    return {
      listReportMutation: listReports,
      updateReportMutation: updateReports,
      // Column Definitions
      columnDefs: [
        {headerName: 'Report ID', field: 'report_id', sortable: true, filter: true, tooltipField: 'report_id'},
        {headerName: 'Name', field: 'name', sortable: true, filter: true, editable: true},
        {headerName: 'Report Type', field: 'report_type', sortable: true, filter: true},
        {headerName: 'Title', field: 'title', sortable: true, filter: true},
        {headerName: 'Subtitle', field: 'subtitle', sortable: true, filter: true},
        {headerName: 'Template ID', field: 'template_id', sortable: true, filter: true},
        {
          headerName: 'Excluded Roles',
          field: 'excluded_roles',
          cellRenderer: 'ListSizeRenderer',
          cellEditor: 'ListEditor',
          tooltipComponent: 'ListTooltip',
          tooltipField: 'excluded_roles',
          sortable: false,
          editable: true,
        },
        {
          headerName: 'Excluded Tags',
          field: 'excluded_tags',
          cellRenderer: 'ListSizeRenderer',
          cellEditor: 'ListEditor',
          tooltipComponent: 'ListTooltip',
          tooltipField: 'excluded_tags',
          sortable: false,
          editable: true,
        },
        {
          headerName: 'Included Tags',
          field: 'included_tags',
          cellRenderer: 'ListSizeRenderer',
          cellEditor: 'ListEditor',
          tooltipComponent: 'ListTooltip',
          tooltipField: 'included_tags',
          sortable: false,
          editable: true,
        },
        {
          headerName: 'Unit Based',
          field: 'unit_based',
          cellRenderer: (params) => (params.value ? 'Yes' : 'No'),
        },
        {headerName: 'Hospital ID', field: 'hospital_id', sortable: true, filter: true, editable: true, cellEditor: 'HospitalSelector'},
      ],
      gridComponents: {
        ListSizeRenderer,
        ListEditor,
        ListTooltip,
        HospitalSelector
      },
      gridContext: {
        componentParent: this, // Will be set in mounted()
      },
      gridApi: null
    };
  },
};
</script>

<style scoped>
</style>
